import { XClose } from '@aktiia/design-system';
import { useEffect, useRef, useState } from 'react';

import { useCloseModal } from '../../../features/modals/hooks';
import { IModalProps } from './types';

export const Modal = ({ name, header, children, footer }: IModalProps) => {
  const closeModal = useCloseModal(name);
  const modalRef = useRef<HTMLDivElement>(null);
  const [modalHeight, setModalHeight] = useState<number>();

  useEffect(() => {
    if (!modalRef.current) {
      return;
    }

    const { height } = modalRef.current.getBoundingClientRect();
    const padding = 24;

    if (window.innerHeight - padding < height) {
      setModalHeight(window.innerHeight - padding);
    }
  }, []);

  return (
    <div className="w-full h-full fixed top-0 left-0 bg-background-backdrop flex items-center justify-center z-50">
      <div className="w-full h-full" onClick={closeModal}></div>

      <div
        ref={modalRef}
        style={{ maxHeight: modalHeight }}
        className="modal fixed bg-background-base-primary w-full max-w-[455px] rounded-xl overflow-auto"
      >
        <div className="flex items-center justify-between py-4 px-6 border-b border-border-light">
          <span className="typography-heading-3 text-text-primary">{header}</span>
          <XClose className="cursor-pointer" onClick={closeModal} />
        </div>

        <div className="typography-paragraph-3 text-text-secondary p-6">{children}</div>

        {footer && <div className="py-4 px-6 border-t border-border-light">{footer}</div>}
      </div>
    </div>
  );
};
